import { IEvent } from "../models/Event";

// dateTime arrives as "dd/mm/yy hh:mm"; the countdown and the registration status use midnight of the event day.
// Parsed by hand because Date's own parsing of "mm/dd/yy" strings differs between browsers. NaN if malformed.
export const getEventDateMs = (event: IEvent): number => {
    const [day, month, year] = (event.dateTime || '').slice(0, 8).split('/').map(Number)
    if (!day || !month || isNaN(year)) return NaN
    return new Date(2000 + year, month - 1, day).getTime()
}

// e.g. "יום שישי, 6 בנובמבר 2026", falling back to the raw date when it can't be parsed
export const formatEventDate = (event: IEvent): string => {
    const dateMs = getEventDateMs(event)
    if (isNaN(dateMs)) return event.date
    return new Intl.DateTimeFormat('he-IL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(dateMs)
}
